import { render, staticRenderFns } from "./CallModalView.vue?vue&type=template&id=1b744dfd&scoped=true&"
import script from "./CallModalView.vue?vue&type=script&lang=ts&"
export * from "./CallModalView.vue?vue&type=script&lang=ts&"
import style0 from "./CallModalView.vue?vue&type=style&index=0&id=1b744dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b744dfd",
  null
  
)

export default component.exports